import { defineStore } from 'pinia';

import { useStore as useShapeStore } from './shape';
import { useStore as useProductStore } from './product';
import { px2mm } from '@/utils';

export const useStore = defineStore({
  id: 'priceSection',

  state: () => {
    return {
      payload: {},
    };
  },
  getters: {},
  actions: {
    resetPriceStateToDefault() {
      this.$patch((state) => {
        state.payload = {};
      });
    },
    prepareEventPayload() {
      const shapeStore = useShapeStore();
      const productStore = useProductStore();

      const positionImageDpi =
        productStore.selectedPrintPosition.originalImageWebDpi;

      const logosByPosition = shapeStore.positionShapeMap.reduce((rv, x) => {
        (rv[x.id] = rv[x.id] || []).push(x.logoId);
        return rv;
      }, {} as { [key: string]: string[] });

      const productPrintPositions = Object.entries(logosByPosition).map(
        ([pId, logoIds]) => {
          const position = productStore.unavailablePrintPositions.find(
            (position) => position.positionId === pId
          );
          const logos = logoIds.map((logoId) => {
            const shape = shapeStore.shapes.find(({ id }) => id === logoId);
            if (shape) {
              return {
                id: shape.id,
                name: shape.kind === 'Logo' ? shape.fileName : shape.w2pText,
                width: shape.width,
                height: shape.height,
              };
            }
          });
          /**
           * NOTE: Until we have a calculation method to calculate bounding box for all logos
           * we will send just the first logo's width and height
           */
          return {
            width: px2mm(logos[0]?.width as number, positionImageDpi),
            height: px2mm(logos[0]?.height as number, positionImageDpi),
            printPositionSAPCode: position?.positionName,
            printTechniqueSAPCode: position?.technique.id,
            numberOfColors: '34',
          };
        }
      );
      return {
        productPrintPositions,
      };
    },
  },
});
